// ─── Configuration d'affichage du calendrier (par calendrier) ─────
// Caractéristiques de présentation des vues Semaine / Jour (grille horaire) :
//   heureDebut / heureFin  = plage d'heures affichée (h pleines)
//   hauteurHeure           = hauteur d'une heure en px (zoom)
//   dureeDefaut            = durée (min) d'un événement sans heure de fin
//   vueDefaut              = vue ouverte au démarrage ('mois'|'semaine'|'jour')
// Stockée sur calendriers/{calId}.affichageConfig (champ ignoré par MoPCal).
import { db } from '@mop/core';
import { doc, setDoc, getDoc } from 'firebase/firestore';

export const CONFIG_DEFAUT = {
  heureDebut: 7,
  heureFin: 22,
  hauteurHeure: 56,
  pasMinutes: 60,
  dureeDefaut: 60,
  vueDefaut: 'mois',
  // Événements HORS de la plage d'heures : true = la grille s'étend pour les
  // montrer (zones teintées « hors plage ») ; false = plage stricte.
  horsPlage: true,
};

export function normaliserConfig(cfg) {
  const c = { ...CONFIG_DEFAUT, ...(cfg || {}) };
  c.heureDebut = Math.max(0, Math.min(23, Number(c.heureDebut) || 0));
  c.heureFin   = Math.max(c.heureDebut + 1, Math.min(24, Number(c.heureFin) || 24));
  c.hauteurHeure = Math.max(32, Math.min(120, Number(c.hauteurHeure) || 56));
  c.pasMinutes   = [15, 30, 45, 60, 120].includes(Number(c.pasMinutes)) ? Number(c.pasMinutes) : 60;
  c.dureeDefaut  = Math.max(15, Math.min(240, Number(c.dureeDefaut) || 60));
  if (!['mois', 'semaine', 'jour'].includes(c.vueDefaut)) c.vueDefaut = 'mois';
  c.horsPlage = c.horsPlage !== false;
  return c;
}

export async function chargerAffichageConfig(calId) {
  if (!calId) return { ...CONFIG_DEFAUT };
  try {
    const snap = await getDoc(doc(db, 'calendriers', calId));
    return normaliserConfig(snap.exists() ? snap.data().affichageConfig : null);
  } catch { return { ...CONFIG_DEFAUT }; }
}

export async function sauvegarderAffichageConfig(calId, cfg) {
  await setDoc(doc(db, 'calendriers', calId), { affichageConfig: normaliserConfig(cfg) }, { merge: true });
}

// Parse une heure stockée ("14:30", "9h30", "14h", "8") → minutes depuis minuit.
export function parseHeureMin(h) {
  if (!h) return null;
  const s = String(h).trim();
  let m = s.match(/^(\d{1,2})[:hH](\d{2})$/);
  if (m) return (+m[1]) * 60 + (+m[2]);
  m = s.match(/^(\d{1,2})[hH]?$/);
  if (m) return (+m[1]) * 60;
  return null;
}
